import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'

import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

import styles from './styles.js'
import { ActionMenu } from '../../../../Components/ActionMenu'

const CustomTable = ({ data = [], classes, headers = [] }) => {
  const renderTableCell = ({ row, key, type, center }) => {
    switch (type) {
      case 'name':
        return row && row[key] ? (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.center]: center,
            })}
          >
            {row[key] || '-'}
          </Typography>
        ) : (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.center]: center,
            })}
          >
            {'-'}
          </Typography>
        )

      case 'actions':
        return <ActionMenu options={row[key]} />

      default:
        return <Typography>{row[key]}</Typography>
    }
  }

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.table}>
        <TableContainer className={classes.tableContainer}>
          <Table stickyHeader size="medium">
            <TableHead className={classes.tableHead}>
              <TableRow className={classes.tableRow}>
                {headers.map((headCell, index) => (
                  <TableCell
                    key={headCell.key}
                    align={index === 0 ? 'left' : 'center'}
                    className={
                      index !== 0
                        ? classes.tableHeaderCell
                        : classes.firstTableHeaderCell
                    }
                  >
                    <Typography className={classes.tableHeadersLabel}>
                      {headCell.label}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map(row => {
                return (
                  <TableRow
                    hover={false}
                    tabIndex={-1}
                    key={row.id}
                    className={classes.tableRow}
                  >
                    {headers.map(({ key, type }, index) => {
                      return (
                        <TableCell align={index ? 'center' : 'left'}>
                          {renderTableCell({
                            row,
                            key,
                            type,
                            center: index,
                          })}
                        </TableCell>
                      )
                    })}
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  )
}

export default injectStyles(styles)(CustomTable)
